<template>
  <list-list
    v-if="showFilm"
    show-owners
    :lists="lists"
  >
    <template #extra-actions="{ list }">
      <v-btn
        text
        color="error"
        :loading="removeLoading"
        @click.prevent.stop="remove(list.id)"
      >Remove</v-btn>
    </template>
    <template #footer>
      <v-btn
        text
        width="100%"
        :loading="switchLoading"
        @click="showAddable"
      >Add To List</v-btn>
    </template>
  </list-list>
  <list-list v-else :lists="addable">
    <template #extra-actions="{ list }">
      <v-btn
        text
        color="success"
        :loading="addLoading"
        @click.prevent.stop="add(list.id)"
      >Add</v-btn>
    </template>
    <template #footer>
      <v-btn text width="100%" @click="showFilm = true">Done</v-btn>
    </template>
  </list-list>
</template>

<script>
import ListList from '@/components/lists/ListList'

export default {
  name: 'FilmLists',
  components: {
    ListList,
  },
  props: {
    id: {
      type: Number | String,
      required: true,
    },
    lists: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showFilm: true,
      addable: [],
      switchLoading: false,
      removeLoading: false,
      addLoading: false,
    }
  },
  inject: ["httpClient"],
  computed: {
    me() {
      return this.$store.state.me
    },
  },
  methods: {
    async showAddable() {
      this.switchLoading = true
      this.addable = await this.httpClient.loadAllLists({
        by: this.me.id,
        for: this.id,
      })
      this.switchLoading = false
      this.showFilm = false
    },
    async add(id) {
      this.addLoading = true
      await this.httpClient.addToList({
        id,
        film_id: this.id,
      })
      const ind = this.addable.findIndex(l => l.id === id)
      const list = this.addable[ind]
      this.addable.splice(ind, 1)
      this.$emit('addList', {list})
      this.addLoading = false
    },
    async remove(id) {
      this.removeLoading = true
      await this.httpClient.removeFromList({
        id,
        film_id: this.id,
      })
      this.$emit('removeList', {id})
      this.removeLoading = false
    },
  },
}
</script>
